exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fmcy-cart-items-empty {\n  padding-top: 30px;\n  text-align: center;\n  font-size: 150%; }\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader/lib/loader.js?name=../css/[name]-[hash].[ext]!./assets/js/common/cart/cart-review/cart-items/cart-items.scss
 ** module id = 528
 ** module chunks = 1 9 15 66
 **/